import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const useAxios = () => {
  const { token } = useContext(AuthContext);

  // Create an instance of Axios
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api",
  });

  // Add the Authorization header if the token exists
  axiosInstance.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  return axiosInstance;
};

export default useAxios;
